export default __webpack_public_path__ + "static/media/Groupe 80.bb6630f0.svg";